// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"style_loading-container__oVX2I","results-title":"style_results-title__cTu_5"};